module.exports = __webpack_public_path__ + "img/logo_bialy.7b87b980.png";